document.addEventListener("turbolinks:load", function() {
  var faxButton = document.querySelector(".test-fax")

  if (faxButton) {faxButton.addEventListener("click", testfax);}

  function testfax(event) {
    event.preventDefault()
    const fax = this.parentNode.parentNode.getElementsByTagName('input')[0].value
    console.log(fax)

    $.ajax({
      url: `/test_fax`,
      type: "post",
      data: {"fax": fax},
      success: function(data){
        alert('Test fax has been sent.')
      },
      error: function(data){
        alert('Error occurred. Test did not go through.')
      }
    });
  }
});
